import React from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';

import { useGlobalContext } from './state/GlobalContext';

const OverlaysWrapper = ({
  children,
}: {
  children?: React.ReactElement | React.ReactElement[];
}): JSX.Element => {
  const { drawerComponent, isDrawerOpen, onDrawerClose, drawerOptions } =
    useGlobalContext();

  return (
    <>
      {children}
      <Drawer
        isOpen={isDrawerOpen}
        onClose={onDrawerClose}
        placement={drawerOptions.placement}
      >
        <DrawerOverlay>
          <DrawerContent>
            {drawerOptions.withCloseButton && (
              <DrawerCloseButton data-testid="drawer-close-button" />
            )}
            {drawerComponent}
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </>
  );
};

export default OverlaysWrapper;
